/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 툴바 내부의 구분자 아이템 클래스를 정의한다.
 *
 * @file /src/components/toolbar/item/separator/Separator.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2025. 11. 4.
 */
import * as parent from '@components/toolbar/item/Item';

export interface Listeners<T> extends parent.Listeners<T> {}

export interface Properties<T> extends parent.Properties<T> {}

export class Separator extends parent.Item {
    /**
     * 컴포넌트 타입
     */
    type = 'toolitem';

    /**
     * 컴포넌트 확장타입
     */
    variant = 'separator';
}
